import MHeader from './MHeader.vue';

MHeader.install = (app) => {
  app.component('MHeader', MHeader);
};

export { MHeader };
